import { Tag } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { GREScoresSchema } from '../../formSchemas';
import { useFieldValues } from '.';

const GreTag = () => {
  const { t } = useTranslation();
  const formValues = useFieldValues();
  const { hasGre } = formValues;
  const { success: greValid } = GREScoresSchema(t).safeParse(formValues);
  const showTag = hasGre && greValid;

  return (
    <>
      {showTag && (
        <Tag icon="fill" intent="positive" onClick={function Na() {}}>
          {t('loans.educationSummary.greText')}
        </Tag>
      )}
    </>
  );
};

export default GreTag;
